// extracted by mini-css-extract-plugin
export default {"mainContainer":"leadTimeTab_mainContainer__f8k-W","tableContainer":"leadTimeTab_tableContainer__FRtk5","table":"leadTimeTab_table__gype6"};